import React, { memo } from 'react'

// app inputs
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'

function FormDimensions(props) {
    const {
        formik
    } = props

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* heading */}
                    <p className="box-heading st-fs-15 st-fw-600 st-text-color mb-2">Dimensions</p>

                    <div className="fields xs-12 col-md-10">
                        {/* form field */}
                        <AppFormikInputInline
                            inputType={"text"}
                            formik={formik} // formik object
                            stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                            labelName={"Weight"} // label name
                            // isRequired={true} // is this field is required or not to show the red star sign
                            placeholder={"Weight"} // placeholder for the input
                            formikFieldName={"weight"} // important: formik value name for the input
                        />

                        {/* form field */}
                        <AppFormikInputInline
                            inputType={"text"}
                            formik={formik} // formik object
                            stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                            labelName={"Length"} // label name
                            // isRequired={true} // is this field is required or not to show the red star sign
                            placeholder={"Length"} // placeholder for the input
                            formikFieldName={"length"} // important: formik value name for the input
                        />

                        {/* form field */}
                        <AppFormikInputInline
                            inputType={"text"}
                            formik={formik} // formik object
                            stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                            labelName={"Width"} // label name
                            // isRequired={true} // is this field is required or not to show the red star sign
                            placeholder={"Width"} // placeholder for the input
                            formikFieldName={"width"} // important: formik value name for the input
                        />

                        {/* form field */}
                        <AppFormikInputInline
                            inputType={"text"}
                            formik={formik} // formik object
                            stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                            labelName={"Height"} // label name
                            // isRequired={true} // is this field is required or not to show the red star sign
                            placeholder={"Height"} // placeholder for the input
                            formikFieldName={"height"} // important: formik value name for the input
                        />
                    </div>

                </div>
            </div>
        </React.Fragment>
    )
}


export default memo(FormDimensions)